import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import { MisterIcon } from "@rtel/mister-icons";
import { Button } from "reactstrap";
import Modal from "src/components/Common/UI/Modal/Modal";
import CreateDepartment from "./CreateDepartment";
import EditDepartment from "./EditDepartment";
import DeleteDepartment from "./DeleteDepartment";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import { useDepartmentsDataViewLogic } from "./hooks/useDepartmentsDataViewLogic";
import { Navigate } from "react-router-dom";


const DepartmentsDataView = () => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent,
    apiTotalRecords
  } = useDepartmentsDataViewLogic();

  const addDepartmentButton: React.FC = () => {
    return (
      <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέα Διεύθυνση`)}
      </Button>
    )
  };

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} showDetails={selectedRowsOfTable.length > 0}/>
  );

  return (
    <>
        {loadingDone && (
          <>
            <Table
                columns={columns}
                data={data}
                defaultOrderByKeyFilter={"id"}
                showNumberOfRows={true}
                rowSelection={true}
                setRowSelection={setSelectedRowsOfTable}
                multipleRowSelection={false}
                actionRowId={"id"}
                debugMode={false}
                noDataFoundTitle="No Departments yet"
                isChangeOrderOrVisibilityEnable={false}
                ButtonsAreaLeft={ActionButtons}
                ButtonsAreaRight={addDepartmentButton}
                hiddenColumnsForUser={["deleted", "id"]}
                textPosition="center"
                maxHeight="33rem"
                numberOfRows={apiTotalRecords}
                numberOfRowsTitle="διευθύνσεις"
            />
          </>
        )}

        <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}  
          size="md"
          >
            {modalEvent.action === "create" && <CreateDepartment handleCloseModal={closeActionModal}/> }
            {modalEvent.action === "edit" && <EditDepartment handleCloseModal={closeActionModal} departmentId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
            {modalEvent.action === "delete" && <DeleteDepartment handleCloseModal={closeActionModal} departmentId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
        </Modal>

        {modalEvent.action === "showDetails" && 
          <Navigate to={`/configuration/unitconfiguration/detailspage/Departments/unittype/${modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1}/unitid`} />
        }

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default DepartmentsDataView;

